import { Link } from 'react-router-dom';
import { Anchor } from '@mantine/core';

import { DetailsViewHeader } from 'components/shared';
import { DYNAMIC_URLS } from 'consts';
import { FormsIcon } from 'icons';

import { Trans } from 'react-i18next';
import { useFormEditContext } from './context';

export const Header = () => {
  const {
    form: {
      name,
      template: { id: templateId, name: templateName },
    },
  } = useFormEditContext();

  return (
    <DetailsViewHeader
      icon={<FormsIcon />}
      title={name}
      description={
        <Trans
          i18nKey="forms:editView.header"
          values={{ name: templateName }}
          components={{
            a: (
              <Anchor
                component={Link}
                to={DYNAMIC_URLS.templateEdit({
                  templateId: templateId.toString(),
                })}
              />
            ),
          }}
        />
      }
    />
  );
};
